import { contractsActions, contractsThunks } from '@/entity'
import { handbookThunks } from '@/entity/handbook'
import { api, getFromLocalStorage } from '@/shared'
import { message } from 'antd'
import { actions } from './actions'
import { getDictionaries } from '@/shared/api/rest/dict/getDictionaries'
import { filterOneKato } from '@/entity/handbook/thunks'
import { t } from 'i18next'
import { sendByBin } from '@/shared/api/rest/oppv'
import { SPHERE_ESTABLISHED_POST_STATE_MAPPING } from '@/constants/sphere_type'

export const getContract = (id, isLocal, localOrRemote = false) => {
	return async (dispatch) => {
		try {
			if (!!id) {
				dispatch(contractsActions.setContractLoading(true))
				const content = localOrRemote ? await api.contracts.getlocalOrRemote(id) : await api.contracts.get(id, isLocal)
				const { ddistrictCode, dregionCode, dlocalityCode, dpositionCode, dcountryCode } = content
				let position, district, region, locality, country
				try {
					;[district, region, locality] = await Promise.all(
						[ddistrictCode, dregionCode, dlocalityCode].map(async (item) =>
							item ? await filterOneKato(item) : Promise.resolve(null)
						)
					)
				} catch (err) {
					dispatch(contractsActions.setContractLoading(false))
				}

				try {
					position = dpositionCode ? await api.shared.getPosition({ code: dpositionCode }) : null
				} catch (err) {
					dispatch(contractsActions.setContractLoading(false))
				}

				try {
					country = dcountryCode ? await api.shared.getCountry({ code: dcountryCode }) : null
				} catch (err) {
					dispatch(contractsActions.setContractLoading(false))
				}
				dispatch(actions.setContract({ ...content, district, region, locality, position, country }))
			}
		} catch (error) {
			message.error(
				t('contract.error_get_contract') +
					(error && error.response && error.response.data ? error.response.data.message : t('unknown_error')),
				10
			)
			dispatch(contractsActions.setContractLoading(false))
		} finally {
			dispatch(contractsActions.setContractLoading(false))
		}
	}
}

export const setAdditionalContract = (contract) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setAdditionalContractIsLoading(true))
			const { dpositionCode, dcountryCode, ddistrictCode, dregionCode, dlocalityCode } = contract
			let position = null
			try {
				position = dpositionCode ? await api.shared.getPosition({ code: dpositionCode }) : null
			} catch (err) {}
			let district, region, locality, country
			try {
				;[district, region, locality] = await Promise.all(
					[ddistrictCode, dregionCode, dlocalityCode].map(async (item) =>
						item ? await filterOneKato(item) : Promise.resolve(null)
					)
				)
			} catch (err) {}
			try {
				country = dcountryCode ? await api.shared.getCountry({ code: dcountryCode }) : null
			} catch (err) {}
			dispatch(
				actions.setAdditionalContractId({
					...contract,
					position,
					country,
					district,
					region,
					locality,
				})
			)
		} catch (err) {
		} finally {
			dispatch(actions.setAdditionalContractIsLoading(false))
		}
	}
}

export const saveAdditionalContract = (data, isEdit = false) => {
	return async (dispatch, getState) => {
		try {
			dispatch(actions.setAdditionalContractIsLoading(true))
			const state = getState()
			const { bin, id: contractId, externalId: contractExternalId, iin } = state?.contracts.contract.data || {}
			const response = await api.contracts.createAdditionalContractXml({
				bin,
				contractId,
				contractExternalId,
				iin,
				...data,
			})
			dispatch(actions.setAdditionalContractXml(response))
		} catch (err) {
			message.error(err.response ? err.response.data.message : t('unknown_error'), 10)
		} finally {
			dispatch(actions.setAdditionalContractIsLoading(false))
		}
	}
}

export const saveLocalAdditionalContract = (data, page, pageSize, filters = {}) => {
	return async (dispatch, getState) => {
		try {
			dispatch(actions.setAdditionalContractIsLoading(true))
			const state = getState()
			const { bin, id: contractId, externalId: contractExternalId, iin } = state?.contracts.contract.data || {}
			await api.contracts.createLocalAdditionalAgreement({
				bin,
				contractId,
				contractExternalId,
				iin,
				...data,
			})
			const { externalId, isLocalContract } = state.contracts.contract.data
			dispatch(contractsThunks.getContract(externalId, isLocalContract))
			dispatch(contractsThunks.getContracts(filters, page, pageSize))
			dispatch(actions.setAdditionalContractSubmitted())
			message.success('Операция успешно выполнена', 10)
		} catch (err) {
			message.error(err.response ? err.response.data.message : t('unknown_error'))
		} finally {
			dispatch(actions.setAdditionalContractIsLoading(false))
		}
	}
}

export const sendAdditionalContract = (signedXml, data, page, pageSize, filters) => {
	return async (dispatch, getState) => {
		try {
			dispatch(actions.setAdditionalContractIsLoading(true))
			const state = getState()
			const { externalId, id, contractNumber, dateFrom, bin, iin, isLocalContract } = state.contracts.contract.data
			const { companyName } = state.company?.company
			const paramMap = {
				addname: data?.contractNum,
				adddate: data?.dateFrom,
				cntrname: contractNumber,
				cntrdate: dateFrom,
				orgfrom: companyName,
				fromBin: bin,
				toIin: iin,
				val1: externalId,
			}
			await api.contracts.sendSignedAdditionalContract({
				signedXml,
				externalId,
				entityId: id,
				paramMap,
			})
			dispatch(contractsThunks.getContract(externalId, isLocalContract))
			dispatch(actions.setAdditionalContractSubmitted())
			dispatch(actions.setAdditionalContractIsLoading(false))
			dispatch(contractsThunks.getContracts(filters, page, pageSize))
			message.success('Операция успешно выполнена', 10)
		} catch (err) {
			message.error(err.response ? err.response.data.message : t('unknown_error'))
			dispatch(contractsActions.setAdditionalContractXml(null))
			dispatch(actions.setAdditionalContractIsLoading(false))
		} finally {
			dispatch(actions.setAdditionalContractIsLoading(false))
		}
	}
}

export const deleteAdditionalContract = () => {
	return async (dispatch, getState) => {
		try {
			dispatch(actions.setAdditionalContractIsLoading(true))
			const state = getState()
			const { contract } = state.contracts.additionalContract
			const response = await api.contracts.getDeleteAdditionalContractXml(contract)
			dispatch(actions.setAdditionalContractXml(response))
		} catch (err) {
			message.error(err.response ? err.response.data.message : t('unknown_error'))
		} finally {
			dispatch(actions.setAdditionalContractIsLoading(false))
		}
	}
}

export const deleteLocalAdditionalContract = () => {
	return async (dispatch, getState) => {
		try {
			dispatch(actions.setAdditionalContractIsLoading(true))
			const state = getState()
			const { externalId } = state.contracts.additionalContract.contract
			await api.contracts.deleteLocalAdditionalAgreement(externalId)
			const { externalId: contractExternalId, isLocalContract } = state.contracts.contract.data
			dispatch(contractsThunks.getContract(contractExternalId, isLocalContract))
			dispatch(actions.setAdditionalContractSubmitted())
			message.success('Операция успешно выполнена', 10)
		} catch (err) {
			message.error(err.response ? err.response.data.message : t('unknown_error'))
		} finally {
			dispatch(actions.setAdditionalContractIsLoading(false))
		}
	}
}

export const getContracts = (data, page, size, cache = false) => {
	return async (dispatch) => {
		try {
			const activeRole = getFromLocalStorage('activeRole')

			dispatch(contractsActions.toggleError(null))
			dispatch(contractsActions.toggleLoading(true))
			dispatch(contractsActions.setParams(data))
			let params = {
				page,
				size,
				employee: activeRole === 'ROLE_EMPLOYEE',
			}
			const res = await api.contracts.getAll(data, params, cache)
			dispatch(contractsActions.setContracts(res))
			dispatch(contractsActions.toggleSuccess(true))
			dispatch(contractsActions.toggleLoading(false))
		} catch (error) {
			dispatch(contractsActions.toggleError(error))
			dispatch(contractsActions.toggleSuccess(false))
			message.error(error?.response?.data?.message)
		} finally {
			dispatch(contractsActions.toggleLoading(false))
		}
	}
}

export const sendSignedContract = (signedXml, force = false, data) => {
	return async (dispatch, getState) => {
		try {
			dispatch(contractsActions.setContractLoading(true))
			const state = getState()
			const { companyName } = state.company?.company
			const contract = state.contracts.contract.data
			const isEdit = state.contracts.isEdit
			const { externalId, contractNumber, registerDate, bin, iin } = data || contract
			const paramMap = {
				cntrname: contractNumber,
				cntrdate: registerDate,
				orgfrom: companyName,
				fromBin: bin,
				toIin: iin,
				val1: externalId,
				isEdit,
			}
			const created = await api.contracts.sendContract({ signedXml, paramMap })
			if (created.success) {
				if (force) {
					const { params, size } = state.contracts
					dispatch(contractsThunks.getContracts(params, 0, size))
				} else {
					const { externalId: contractExternalId, isLocalContract } = state.contracts.contract.data
					dispatch(contractsThunks.getContract(contractExternalId, isLocalContract))
				}
				dispatch(contractsActions.setContractSuccess(true))
				message.success('Данные отправлены успешно', 10)
			} else {
				dispatch(contractsActions.setContractSuccess(false))
			}
		} catch (error) {
			dispatch(contractsActions.setContractSuccess(false))
			dispatch(contractsActions.setContractLoading(false))
			message.error('Ошибка отправки данных:' + (error.response ? error.response.data.message : t('unknown_error')))
			dispatch(contractsActions.setContractError(true))
			dispatch(contractsActions.setContractLoading(false))
		} finally {
			dispatch(contractsActions.setContractLoading(false))
		}
	}
}

export const createLocalContract = (data, isEdit = false) => {
	return async (dispatch, getState) => {
		try {
			dispatch(contractsActions.setContractLoading(true))
			if (data.isResident) data.foreignLaborInfo = null
			const created = await api.profile.createContract(data)
			if (created.success) {
				const state = getState()
				if (isEdit) {
					const { contracts } = state.contracts
					dispatch(
						contractsActions.setContracts({
							...state.contracts,
							content: contracts.map((contract) => {
								if (contract.externalId === data.externalId) contract.externalId = created.data.externalId
								return contract
							}),
						})
					)
					dispatch(contractsActions.setContract({ ...created.data }))
				}
				if (!isEdit) {
					const { params, size } = state.contracts
					dispatch(contractsThunks.getContracts(params, 0, size))
				}
				dispatch(contractsActions.setContractSuccess(true))
				message.success('Операция выполнена успешно', 10)
			} else {
				dispatch(contractsActions.setContractSuccess(false))
			}
		} catch (error) {
			dispatch(contractsActions.setContractSuccess(false))
			dispatch(contractsActions.setContractLoading(false))
			message.error('Ошибка сохранения данных:' + error.response ? error.response.data.message : t('unknown_error'))
		} finally {
			dispatch(contractsActions.setContractLoading(false))
		}
	}
}

export const deleteLocalContract = (externalId) => {
	return async (dispatch, getState) => {
		try {
			dispatch(actions.setContractLoading(true))
			const state = getState()
			const { contracts } = state.contracts
			const created = await api.contracts.deleteLocalContract(externalId)
			if (created.success) {
				message.success('Данные успешно удалены', 10)
				dispatch(contractsActions.setContractSuccess(true))
				dispatch(
					contractsActions.setContracts({
						...state.contracts,
						content: contracts.filter((contract) => contract.externalId !== externalId),
					})
				)
			} else {
				dispatch(contractsActions.setContractSuccess(false))
			}
		} catch (error) {
			dispatch(contractsActions.setContractSuccess(false))
			message.error('Ошибка удаления данных:' + (error.response ? error.response.data.message : t('unknown_error')))
		} finally {
			dispatch(actions.setContractLoading(false))
		}
	}
}

export const sendTerminate = (signedXml) => {
	return async (dispatch, getState) => {
		try {
			dispatch(actions.setTerminationIsLoading(true))
			const state = getState()
			const { id, externalId, contractNumber, dateFrom, bin, iin } = state.contracts.contract.data
			const { companyName } = state.company?.company
			const paramMap = {
				cntrname: contractNumber,
				cntrdate: dateFrom,
				orgfrom: companyName,
				fromBin: bin,
				toIin: iin,
				val1: externalId,
			}
			await api.contracts.terminate({
				signedXml,
				externalId,
				entityId: id,
				paramMap,
			})
			dispatch(actions.setTerminationIsSuccess(true))
			message.success('Прекращение/расторжение договора успешно выполнено', 5)
			dispatch(actions.setContractSuccess(true))
		} catch (error) {
			message.error(
				'Ошибка прекращения/расторжения договора:' + (error.response ? error.response.data.message : t('unknown_error'))
			)
			dispatch(actions.resetTermination())
			message.error('Ошибка удаления данных:' + (error.response ? error.response.data.message : t('unknown_error')))
			dispatch(actions.setContractSuccess(false))
		} finally {
			dispatch(actions.setTerminationIsLoading(false))
		}
	}
}

export const generateRemoveXML = (externalId) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setContractLoading(true))
			const contractXml = await api.contracts.deleteXml(externalId)
			dispatch(actions.setRemoveXML(contractXml))
		} catch (error) {
			message.error('Ошибка удаления данных:' + (error.response ? error.response.data.message : t('unknown_error')))
			dispatch(actions.setContractSuccess(false))
		} finally {
			dispatch(actions.setContractLoading(false))
		}
	}
}

export const generateRecoverXML = (data) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setContractLoading(true))
			const xml = await api.contracts.generateRecoverXml(data)
			dispatch(actions.setRecoverXML({ data: xml }))
		} catch (error) {
			message.error('Ошибка удаления данных:' + (error.response ? error.response.data.message : t('unknown_error')))
			dispatch(actions.setContractSuccess(false))
		} finally {
			dispatch(actions.setContractLoading(false))
		}
	}
}

export const recover = (data) => {
	return async (dispatch, getState) => {
		try {
			dispatch(actions.setContractLoading(true))
			const state = getState()
			const { contractNumber, dateFrom, bin, iin } = state.contracts?.contract.data
			const { companyName } = state.company?.company
			const paramMap = {
				cntrname: contractNumber,
				cntrdate: dateFrom,
				orgfrom: companyName,
				fromBin: bin,
				toIin: iin,
			}
			const response = await api.contracts.recoverXml({ ...data, paramMap })
			dispatch(actions.setRecoverXML({ data: null, open: false, response, error: null }))
		} catch (error) {
			dispatch(
				actions.setRecoverXML({
					data: null,
					open: false,
					error: error.response ? error.response.data.message : t('unknown_error'),
					response: null,
				})
			)
		} finally {
			dispatch(actions.setContractLoading(false))
		}
	}
}

export const generateExternalRemoveXML = (data) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setContractLoading(true))
			const contractXml = await api.contracts.deleteExternalXml(data)
			dispatch(actions.setRemoveXML(contractXml))
		} catch (error) {
			message.error('Ошибка удаления данных:' + (error.response ? error.response.data.message : t('unknown_error')))
			dispatch(actions.setContractSuccess(false))
		} finally {
			dispatch(actions.setContractLoading(false))
		}
	}
}

export const edit = (data) => {
	return async (dispatch, getState) => {
		try {
			dispatch(contractsActions.setContractLoading(true))
			const state = getState()
			const { externalId, contractNumber, dateFrom, bin, iin } = state.contracts?.contract.data
			const { companyName } = state.company?.company
			const paramMap = {
				cntrname: contractNumber,
				cntrdate: dateFrom,
				orgfrom: companyName,
				fromBin: bin,
				toIin: iin,
				isEdit: true,
			}
			await api.contracts.sendContract({ externalId, signedXml: data, paramMap })
			dispatch(contractsThunks.getContract(externalId, false))
			message.success('Данные обновлены успешно', 10)
			dispatch(contractsActions.setContractSuccess(true))
			dispatch(contractsActions.setContractLoading(false))
		} catch (error) {
			message.error('Ошибка обновления данных:' + error.response ? error.response.data.message : t('unknown_error'))
			dispatch(actions.resetEditing())
			dispatch(contractsActions.setContractLoading(false))
		} finally {
			dispatch(contractsActions.setContractLoading(false))
		}
	}
}

export const generateEditXML = (data) => {
	return async (dispatch) => {
		try {
			dispatch(contractsActions.setContractLoading(true))
			if (data.isResident) data.foreignLaborInfo = null
			const contractXml = await api.contracts.getEditXml(data)
			dispatch(actions.setEditXML(contractXml))
		} catch (err) {
			dispatch(contractsActions.setContractLoading(false))
		} finally {
			dispatch(contractsActions.setContractLoading(false))
		}
	}
}

export const generateLocalEditXML = (externalId) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setContractLoading(true))
			const contractXml = await api.contracts.getXml(externalId)
			dispatch(actions.setEditXML(contractXml))
		} catch (error) {
			message.error('Ошибка:' + error.response ? error.response.data.message : t('unknown_error'))
			dispatch(actions.setContractError(true))
		} finally {
			dispatch(actions.setContractLoading(false))
		}
	}
}

export const remove = (data) => {
	return async (dispatch, getState) => {
		try {
			dispatch(actions.setContractLoading(true))
			const state = getState()
			const { contractNumber, dateFrom, bin, iin } = state.contracts.contract.data
			const { companyName } = state.company?.company
			const paramMap = {
				cntrname: contractNumber,
				cntrdate: dateFrom,
				orgfrom: companyName,
				fromBin: bin,
				toIin: iin,
			}
			await api.contracts.remove({ ...data, paramMap })
			message.success('Данные удалены успешно', 10)
			dispatch(actions.setRemoveXML(null))
			const { params, size } = state.contracts
			dispatch(contractsThunks.getContracts(params, 0, size))
			dispatch(actions.setContractSuccess(true))
		} catch (error) {
			message.error('Ошибка:' + error.response ? error.response.data.message : t('unknown_error'))
			dispatch(actions.setContractSuccess(false))
		} finally {
			dispatch(actions.setContractLoading(false))
		}
	}
}

export const getOptions = () => {
	return (dispatch, getState) => {
		const handbook = getState().handbook
		const {
			contractTerms,
			positions,
			jobTypes,
			workingTimeModes,
			countries,
			districts,
			professionalSkills,
			personalQualities,
			remoteWorkTypes,
			contractTypes,
			sendStatuses,
			esutdRegErrors,
			socialLeaveTypes,
			restoreOrganizationTypes,
			restoreOrganizationCourts,
			positionsByKnz,
			contractStatuses,
			contractStates,
			workActivityTypes,
			workCondition,
			extraGuaranteesCollectiveContract,
			unionTypeCollectiveContract,
			workActivityTypeGroups,
			nonresidentAttractingBasis,
			nonresidentEducation,
			ccEnterpriseType,
			ccOwnershipType,
			industryAgreement,
			establishedPostPositionCategoryRelation,
		} = getState().handbook
		const activeCompany = getFromLocalStorage('activeCompany')

		const terminationReasons = getState().contracts.terminationReasons

		if (!contractStatuses?.length > 0) dispatch(handbookThunks.getContractStatuses())
		if (!contractStates?.length > 0) dispatch(handbookThunks.getContractStates())
		if (!contractTerms?.length > 0) dispatch(handbookThunks.getContractTerms())
		if (!positionsByKnz?.length > 0) dispatch(handbookThunks.getPositionsByKnz())
		if (!workCondition?.length > 0) dispatch(handbookThunks.getWorkCondition())
		if (!extraGuaranteesCollectiveContract?.length > 0) dispatch(handbookThunks.getExtraGuaranteesCollectiveContract())
		if (!unionTypeCollectiveContract?.length > 0) dispatch(handbookThunks.getUnionTypeCollectiveContract())
		if (!socialLeaveTypes?.length > 0) dispatch(handbookThunks.getSocialLeaveTypes())
		if (!restoreOrganizationTypes?.length > 0) dispatch(handbookThunks.getRestoreOrganizationTypes())
		if (!restoreOrganizationCourts?.length > 0) dispatch(handbookThunks.getRestoreOrganizationCourts())
		if (!positions?.length > 0) dispatch(handbookThunks.getPositions())
		if (!jobTypes?.length > 0) dispatch(handbookThunks.getJobTypes())
		if (!workingTimeModes?.length > 0) dispatch(handbookThunks.getWorkingTimeModes())
		if (!countries?.length > 0) dispatch(handbookThunks.getCountries())
		if (!districts?.length > 0) dispatch(handbookThunks.getDistrictsAuth())
		if (!professionalSkills?.length > 0) dispatch(handbookThunks.getProfessionalSkills())
		if (!personalQualities?.length > 0) dispatch(handbookThunks.getPersonalQualities())
		if (!remoteWorkTypes?.length > 0) dispatch(handbookThunks.getRemoteWorkTypes())
		if (!sendStatuses?.length > 0) dispatch(handbookThunks.sendStatuses())
		if (!esutdRegErrors?.length > 0) dispatch(handbookThunks.esutdRegErrors())
		if (!contractTypes?.length > 0) dispatch(handbookThunks.getContractTypes())
		if (!terminationReasons?.length > 0) dispatch(contractsThunks.getTerminationReasons())
		if (!workActivityTypes?.length > 0) dispatch(handbookThunks.getWorkActivityTypes())
		if (!workActivityTypeGroups?.length > 0) dispatch(handbookThunks.getWorkActivityGroup())
		if (!nonresidentAttractingBasis?.length > 0) dispatch(handbookThunks.getNonresidentAttractingBasis())
		if (!nonresidentEducation?.length > 0) dispatch(handbookThunks.getNonresidentEducation())
		if (!ccEnterpriseType?.length > 0) dispatch(handbookThunks.getCcEnterpriseType())
		if (!ccOwnershipType?.length > 0) dispatch(handbookThunks.getCcOwnershipType())
		if (!industryAgreement?.length > 0) dispatch(handbookThunks.getIndustryAgreement())
		if (!establishedPostPositionCategoryRelation?.length > 0) dispatch(handbookThunks.getCategoryRelation())

		if (activeCompany?.sphereType) {
			const sphereType = activeCompany?.sphereType
			const stateFieldName = SPHERE_ESTABLISHED_POST_STATE_MAPPING[sphereType]

			if (stateFieldName && (!handbook[stateFieldName] || handbook[stateFieldName].length < 1)) {
				dispatch(handbookThunks.getEstablishedPostBySphere(sphereType, stateFieldName))
			}
		}
	}
}

export const getTerminationReasons = () => {
	return async (dispatch) => {
		try {
			dispatch(contractsActions.toggleLoading(true))
			const { content } = await getDictionaries('termReason', { size: 999 })
			dispatch(actions.setTerminationReasons(content))
		} catch (err) {
			dispatch(contractsActions.toggleLoading(false))
		} finally {
			dispatch(contractsActions.toggleLoading(false))
		}
	}
}

export const submitTerminationData = (data) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setTerminationIsLoading(true))
			const { bin, externalId } = data
			const response = await api.contracts.terminateContract({
				...data,
				bin,
				externalId,
			})
			dispatch(actions.setTerminateXML(response))
		} catch (error) {
			message.error('Ошибка обновления данных:' + error.response ? error.response.data.message : t('unknown_error'))
			dispatch(actions.resetTermination())
		} finally {
			dispatch(actions.setTerminationIsLoading(false))
		}
	}
}

export const getDataByBin = (params) => {
	return async (dispatch) => {
		try {
			dispatch(actions.getDataByBinStart())
			const response = await api.contracts.getDataByBin(params)
			dispatch(actions.getDataByBin(response))
		} catch (error) {
			dispatch(actions.getDataByBinError(error?.response?.data?.message))
		}
	}
}

export const getEmployerPermissionByBin = (bin) => {
	return async (dispatch) => {
		try {
			dispatch(actions.getEmployerPermissionByBinStart())
			const response = await api.contracts.getEmployerPermissionByBin(bin)
			dispatch(actions.getEmployerPermissionByBin(response))
		} catch (error) {
			dispatch(actions.getEmployerPermissionByBinError(error?.response?.data?.message))
		}
	}
}

export const getFLData = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setLoadingUpdateIin(true))
			const response = await api.contracts.getFLData(data)
			dispatch(actions.getFLData(response))
			if (onSuccess) {
				onSuccess(response)
				dispatch(actions.setLoadingUpdateIin(false))
			}
			return response
		} catch (error) {
			if (onError) {
				onError(error)
			}
			dispatch(actions.setLoadingUpdateIin(false))
			dispatch(actions.reorganizeError(error?.response?.data))
		} finally {
			dispatch(actions.setLoadingUpdateIin(false))
		}
	}
}

export const getFlDataForEtd = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setLoadingUpdateIin(true))
			const response = await api.contracts.requestFlData(data)
			dispatch(actions.getFLData(response))
			if (onSuccess) {
				onSuccess(response)
				dispatch(actions.setAge(response?.age))
				dispatch(actions.setLoadingUpdateIin(false))
			}
			return response
		} catch (error) {
			if (onError) {
				onError(error)
			}
			dispatch(actions.setLoadingUpdateIin(false))
			dispatch(actions.reorganizeError(error?.response?.data))
		}
	}
}

export const getXmlForUpdateIin = (data) => {
	return async (dispatch) => {
		try {
			const response = await api.contracts.getXmlForUpdateIin(data)
			dispatch(actions.getXmlForUpdateIin(response))
		} catch (error) {
			dispatch(actions.reorganizeError(error?.response?.data))
		}
	}
}

export const getReorganizeXml = (data) => {
	return async (dispatch) => {
		try {
			dispatch(actions.getXmlToReorganizeLoading())
			const response = await api.contracts.getReorganizeXml(data)
			dispatch(actions.getReorganizeXml(response))
		} catch (error) {
			dispatch(actions.reorganizeError(error?.response?.data))
		}
	}
}

export const sendSignedXml = (data) => {
	return async (dispatch) => {
		try {
			dispatch(actions.getXmlToReorganizeLoading())
			const response = await api.contracts.sendSignedXml(data)
			if (response[0].success) {
				dispatch(actions.sendSignedXml(response))
			} else {
				dispatch(actions.setReorganizeSuccess(response))
			}
		} catch (error) {
			dispatch(actions.reorganizeError(error?.response?.data))
		}
	}
}

export const sendUpdateIinXml = (data) => {
	return async (dispatch) => {
		try {
			const response = await api.contracts.sendUpdateIinXml(data)
			dispatch(actions.sendUpdateIinXml(response))
		} catch (error) {
			dispatch(actions.setErrorUpdateIin(error?.response?.data))
		}
	}
}

export const deleteSocialLeave = (socialLeave) => {
	return async (dispatch, getState) => {
		try {
			dispatch(contractsActions.setSocialLeaveIsLoading(true))
			const state = getState()
			const {
				bin,
				externalId: contractExternalId,
				dcontractState,
				entryDate,
				iin,
				id,
			} = state.contracts.contract.data || {}
			const xml = await api.contracts.deleteSocialLeaveXml({
				...socialLeave,
				id,
				bin,
				contractExternalId,
				dcontractState,
				entryDate,
				iin,
				status: socialLeave.status?.code ? 'SIGNED' : 'NOT_SIGNED',
				dleaveTypeCode: socialLeave.dleaveTypeCode.value,
			})
			dispatch(contractsActions.setSocialLeaveXML(xml))
		} catch (error) {
			message.error(error.response ? error.response.data.message : t('unknown_error'))
		} finally {
			dispatch(contractsActions.setSocialLeaveIsLoading(false))
		}
	}
}

export const deleteLocalSocialLeave = (externalId) => {
	return async (dispatch, getState) => {
		try {
			dispatch(contractsActions.setSocialLeaveIsLoading(true))
			const state = getState()
			await api.contracts.deleteLocalSocialLeave(externalId)
			const { externalId: contractExternalId, isLocalContract } = state.contracts.contract.data || {}
			dispatch(contractsThunks.getContract(contractExternalId, isLocalContract))
			message.success('Операция успешно выполнена', 10)
			dispatch(contractsActions.setSocialLeaveIsSuccess(true))
		} catch (error) {
			message.error(error.response ? error.response.data.message : t('unknown_error'))
		} finally {
			dispatch(contractsActions.setSocialLeaveIsLoading(false))
		}
	}
}

export const sendSignedSocialLeave = (signedXml, paramMap, page = 0, pageSize = 10, filters) => {
	return async (dispatch, getState) => {
		try {
			dispatch(contractsActions.setSocialLeaveIsLoading(true))
			const state = getState()
			const { externalId, id, contractNumber, dateFrom, bin, iin, isLocalContract } =
				state.contracts.contract.data || {}
			const { companyName } = state.company.company
			await api.contracts.sendSignedSocialLeave({
				signedXml,
				externalId,
				entityId: id,
				paramMap: {
					cntrname: contractNumber,
					cntrdate: dateFrom,
					orgfrom: companyName,
					fromBin: bin,
					toIin: iin,
					// leavetype: formData?.dleaveTypeCode || socialLeave?.dleaveTypeCode?.value,
					...paramMap,
				},
			})
			dispatch(contractsThunks.getContract(externalId, isLocalContract))
			dispatch(contractsActions.setSocialLeaveIsSuccess(true))
			message.success('Операция выполнена успешно', 10)
			dispatch(contractsThunks.getContracts(filters, page, pageSize))
		} catch (error) {
			message.error(error.response ? error.response.data.message : t('unknown_error'))
			dispatch(contractsActions.resetSocialLeave())
		} finally {
			dispatch(contractsActions.setSocialLeaveIsLoading(false))
		}
	}
}

export const createSocialLeave = (data) => {
	return async (dispatch, getState) => {
		try {
			dispatch(contractsActions.setSocialLeaveIsLoading(true))
			const state = getState()
			const {
				bin,
				externalId: contractExternalId,
				dcontractState,
				entryDate,
				iin,
				id,
			} = state.contracts.contract.data || {}
			const xml = await api.contracts.createSocialLeaveXml({
				...data,
				id,
				bin,
				contractExternalId,
				dcontractState,
				entryDate,
				iin,
			})
			dispatch(contractsActions.setSocialLeaveXML(xml))
		} catch (error) {
			message.error(error.response ? error.response.data.message : t('unknown_error'))
			dispatch(contractsActions.resetSocialLeave())
		} finally {
			dispatch(contractsActions.setSocialLeaveIsLoading(false))
		}
	}
}

export const createLocalSocialLeave = (data) => {
	return async (dispatch, getState) => {
		try {
			dispatch(contractsActions.setSocialLeaveIsLoading(true))
			const state = getState()
			const {
				bin,
				externalId: contractExternalId,
				dcontractState,
				entryDate,
				iin,
				id,
				isLocalContract,
			} = state.contracts.contract.data || {}
			await api.contracts.createLocalSocialLeave({
				id,
				bin,
				contractExternalId,
				dcontractState,
				entryDate,
				iin,
				...data,
			})
			dispatch(contractsThunks.getContract(contractExternalId, isLocalContract))
			dispatch(contractsActions.setSocialLeaveIsSuccess(true))
			message.success('Операция успешно выполнена', 10)
		} catch (error) {
			message.error(error.response ? error.response.data.message : t('unknown_error'))
		} finally {
			dispatch(contractsActions.setSocialLeaveIsLoading(false))
		}
	}
}

export const createProlongation = (data) => {
	return async (dispatch) => {
		try {
			dispatch(contractsActions.setProlongationIsLoading(true))
			const xml = await api.contracts.getProlongationXml(data)
			dispatch(contractsActions.setProlongationXML(xml))
		} catch (error) {
			message.error('Ошибка обновления данных:' + error.response ? error.response.data.message : t('unknown_error'))
			dispatch(contractsActions.resetProlongation())
		} finally {
			dispatch(contractsActions.setProlongationIsLoading(false))
		}
	}
}

export const sendProlongation = (signedXml) => {
	return async (dispatch, getState) => {
		try {
			dispatch(contractsActions.setProlongationIsLoading(true))
			const state = getState()
			const contractData = state?.contracts.contract.data || {}
			await api.contracts.sendSignedProlongationXml({
				signedXml: signedXml || null,
				externalId: contractData?.externalId || null,
				entityId: contractData?.id || null,
			})
			message.success('Пролонгация прошла успешно!', 10)
			dispatch(contractsThunks.getContract(contractData?.externalId, false))
			dispatch(contractsActions.setProlongationIsSuccess(true))
		} catch (error) {
			message.error('Ошибка обновления данных:' + error?.response ? error?.response.data?.message : t('unknown_error'))
			dispatch(contractsActions.resetProlongation())
		} finally {
			dispatch(contractsActions.setProlongationIsLoading(false))
		}
	}
}

export const getXmlToSignSome =
	({ data, onSuccess }) =>
	async (dispatch) => {
		try {
			dispatch(contractsActions.getXmlToSignSomeLoading())
			const response = await api.packageLoading.getXmlToSignSome(data)
			dispatch(contractsActions.getXmlToSignSome(response))
			onSuccess(response)
			dispatch(contractsActions.resetPackage())
		} catch (error) {
			dispatch(contractsActions.resetPackage())
			dispatch(contractsActions.getXmlToSignSomeError(error?.response?.data?.message || t('unknown_error')))
			message.error(error.response ? error.response.data.message : t('unknown_error'))
		}
	}

export const sendSignedXmlPackageSome =
	(body, params, filters = {}, page = 0, pageSize = 10) =>
	async (dispatch, getState) => {
		try {
			dispatch(contractsActions.getXmlToSignSomeLoading())
			const response = await api.packageLoading.sendSignedXmlPackageSome(body, params)
			dispatch(contractsActions.sendSignedXmlPackageSome(response))
			dispatch(contractsThunks.getContracts(filters, page, pageSize))
			const state = getState()
			const { externalId } = state.contracts.contract.data || {}
			if (externalId) {
				dispatch(contractsThunks.getContract(externalId, false))
			}
		} catch (error) {
			dispatch(contractsActions.getXmlToSignSomeError(error?.response?.data?.message || t('unknown_error')))
			message.error(error.response ? error.response.data.message : t('unknown_error'))
		}
	}

export const deleteContracts = (body, filters, page, pageSize) => async (dispatch) => {
	try {
		dispatch(contractsActions.getXmlToSignSomeLoading())
		const response = await api.packageLoading.deleteContracts(body)

		dispatch(contractsActions.deleteContracts(response || {}))
		dispatch(contractsThunks.getContracts(filters, page, pageSize))
	} catch (error) {
		dispatch(contractsActions.getXmlToSignSomeError(error?.response?.data?.message || t('unknown_error')))
		message.error(error.response ? error.response.data.message : t('unknown_error'))
	}
}

export const getEtd = (payload) => async (dispatch) => {
	try {
		dispatch(
			contractsActions.setCurrentEtd({
				data: null,
				loading: true,
				error: null,
			})
		)
		const response = await api.contracts.getEtd(payload)
		dispatch(
			contractsActions.setCurrentEtd({
				data: response,
				loading: false,
				error: null,
			})
		)
	} catch (error) {
		const err = error?.response?.data?.message || t('unknown_error')
		dispatch(
			contractsActions.setCurrentEtd({
				data: null,
				loading: false,
				error: err,
			})
		)
		message.error(err ? err : t('unknown_error'))
	}
}

export const getEtdEdit = (payload) => async (dispatch) => {
	try {
		dispatch(
			contractsActions.setCurrentEtdEdit({
				data: null,
				loading: true,
				error: null,
			})
		)
		const response = await api.contracts.getEtdEdit(payload)
		dispatch(
			contractsActions.setCurrentEtdEdit({
				data: response,
				loading: false,
				error: null,
			})
		)
	} catch (error) {
		const err = error?.response?.data?.message || t('unknown_error')
		dispatch(
			contractsActions.setCurrentEtdEdit({
				data: null,
				loading: false,
				error: err,
			})
		)
		message.error(err ? err : t('unknown_error'))
	}
}

export const sendToEmployee = (payload) => async (dispatch) => {
	try {
		dispatch(
			contractsActions.sendToEmployee({
				data: null,
				loading: true,
				error: null,
			})
		)
		const response = await api.contracts.sendtoEmployee(payload)
		dispatch(
			contractsActions.sendToEmployee({
				data: response,
				loading: false,
				error: null,
			})
		)
	} catch (error) {
		const err = error?.response?.data?.message || t('unknown_error')
		dispatch(
			contractsActions.sendToEmployee({
				data: null,
				loading: false,
				error: err,
			})
		)
		message.error(err ? err : t('unknown_error'))
	} finally {
		dispatch(
			contractsActions.sendToEmployee({
				data: null,
				loading: false,
				error: null,
			})
		)
	}
}

export const declineEmployee = (payload) => async (dispatch) => {
	try {
		dispatch(
			contractsActions.declineEmployee({
				data: null,
				loading: true,
				error: null,
			})
		)
		const response = await api.contracts.declineEmployee(payload)
		dispatch(
			contractsActions.declineEmployee({
				data: response,
				loading: false,
				error: null,
			})
		)
	} catch (error) {
		const err = error?.response?.data?.message || t('unknown_error')
		message.error(err ? err : t('unknown_error'), 5)
		dispatch(
			contractsActions.declineEmployee({
				data: null,
				loading: false,
				error: err,
			})
		)
	}
}

export const sendForImprovementEmployee = (payload) => async (dispatch) => {
	try {
		dispatch(
			contractsActions.sendForImprovementEmployee({
				data: null,
				loading: true,
				error: null,
			})
		)
		const response = await api.contracts.sendForImprovementEmployee(payload)
		dispatch(
			contractsActions.sendForImprovementEmployee({
				data: response,
				loading: false,
				error: null,
			})
		)
	} catch (error) {
		const err = error?.response?.data?.message || t('unknown_error')
		message.error(err ? err : t('unknown_error'), 5)
		dispatch(
			contractsActions.sendForImprovementEmployee({
				data: null,
				loading: false,
				error: err,
			})
		)
	}
}

export const declineEmployer = (payload) => async (dispatch) => {
	try {
		dispatch(
			contractsActions.declineEmployer({
				data: null,
				loading: true,
				error: null,
			})
		)
		const response = await api.contracts.declineEmployer(payload)
		dispatch(
			contractsActions.declineEmployer({
				data: response,
				loading: false,
				error: null,
			})
		)
	} catch (error) {
		const err = error?.response?.data?.message || t('unknown_error')
		dispatch(
			contractsActions.declineEmployer({
				data: null,
				loading: false,
				error: err,
			})
		)
		message.error(err ? err : t('unknown_error'))
	}
}

export const revertEmployer = (payload, onClose, updateList) => async (dispatch) => {
	try {
		const response = await api.contracts.revertEmployer(payload)
		if (response.success) {
			onClose()
			updateList()
		}
	} catch (error) {
		const err = error?.response?.data?.message || t('unknown_error')
		dispatch(
			contractsActions.declineEmployer({
				data: null,
				loading: false,
				error: err,
			})
		)
		message.error(err ? err : t('unknown_error'))
	}
}

export const deleteEtd = (payload) => async (dispatch) => {
	try {
		dispatch(
			contractsActions.deleteEtd({
				data: null,
				loading: true,
				error: null,
			})
		)
		const response = await api.contracts.deleteEtd(payload)
		dispatch(
			contractsActions.deleteEtd({
				data: response,
				loading: false,
				error: null,
			})
		)
	} catch (error) {
		const err = error?.response?.data?.message || t('unknown_error')
		dispatch(
			contractsActions.deleteEtd({
				data: null,
				loading: false,
				error: err,
			})
		)
		message.error(err ? err : t('unknown_error'))
	}
}

export const saveProject = (payload, contract, isSendToEmployee) => {
	return async (dispatch) => {
		try {
			dispatch(
				contractsActions.saveProject({
					data: null,
					loading: true,
					error: null,
				})
			)
			const data = {
				externalId: contract.externalId,
				valueList: payload,
			}
			const params = {
				isSend: isSendToEmployee,
			}
			const response = await api.contracts.saveProject(data, params)
			dispatch(
				contractsActions.saveProject({
					data: response,
					loading: false,
					error: null,
				})
			)
			dispatch(
				contractsActions.setCurrentEtd({
					data: null,
					loading: false,
					error: null,
				})
			)
			dispatch(
				contractsActions.setCurrentEtdEdit({
					data: null,
					loading: false,
					error: null,
				})
			)
			message.success('Успешно сохранено', 5)
		} catch (error) {
			const err = error?.response?.data?.message || t('unknown_error')
			dispatch(
				contractsActions.saveProject({
					data: null,
					loading: false,
					error: err,
				})
			)
			message.error(err ? err : t('unknown_error'))
		}
	}
}

export const getStatusQrSign = (key) => {
	return async (dispatch) => {
		try {
			const response = await api.contracts.mGov.getStatusSign(key)
			dispatch(contractsActions.setStatusSignEtd(response))
			if (response.code === 'sign_success') {
				dispatch(contractsActions.etdToggleSuccess(true))
			}
		} catch (error) {
			const err = error?.response?.data?.message || t('unknown_error')
			message.error(err, 5)
			dispatch(contractsActions.etdToggleSuccess(false))
		}
	}
}

export const getImageQr = (externalId, action) => {
	return async (dispatch) => {
		try {
			dispatch(contractsActions.etdToggleLoading(true))
			const { key, qrCode } = await api.contracts.mGov.getQR(externalId, action)
			const image = new Image()
			image.src = `data:image/png;base64,${qrCode}`
			image.onload = () => {
				dispatch(contractsActions.setImageEtd(image.src))
				dispatch(contractsActions.setImageKey(key))
			}
			dispatch(contractsActions.etdToggleLoading(false))
		} catch (error) {
			dispatch(contractsActions.setErrorEtd(error))
			dispatch(contractsActions.etdToggleLoading(false))
		} finally {
			dispatch(contractsActions.etdToggleLoading(false))
		}
	}
}

export const getOopvSendByBin = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(contractsActions.getOopvSendBin())

			const res = await sendByBin(data)
			if (res) {
				dispatch(contractsActions.getOopvSendBinDone(res))
				onSuccess && onSuccess(res)
				return res
			}
		} catch (error) {
			message.error(error.response?.data?.message)
			onError && onError(error)
			dispatch(contractsActions.getOopvSendBinFail())
		}
	}
}

export const getStatusKdpFamily = async (externalId, type) => {
	try {
		const actionsMap = {
			eAdContract: api.contracts.getAdStatusKdpFamilyForEmployee,
			eContractTerm: api.contracts.getTermStatusKdpFamilyForEmployee,
		}

		const apiCall = actionsMap[type] || api.contracts.getStatusKdpFamilyForEmployee

		return await apiCall({ externalId: externalId })
	} catch (error) {
		message.error(error.response ? error.response.data.message : 'Ошибка получения статуса')
	}
}

export const sendKdpFamily = ({ data, onSuccess, type }) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setFamilyLoading(true))
			const { externalId, guardian } = data

			// Варианты функций, сопоставленных типам
			const actionsMap = {
				eAdContract: api.contracts.sendAdKdpFamily,
				eContractTerm: api.contracts.sendTermKdpFamily,
			}

			// Выбираем нужную функцию или используем дефолтную
			const apiCall = actionsMap[type] || api.contracts.sendKdpFamily

			// Запрос
			const res = await apiCall({ externalId, guardian })

			if (res && onSuccess(res)) {
				dispatch(actions.setFamilyLoading(false))
			}
		} catch (error) {
			dispatch(actions.setFamilyLoading(false))
			message.error(error.response ? error.response.data.message : 'Ошибка отправки запроса')
		} finally {
			dispatch(actions.setFamilyLoading(false))
		}
	}
}

export const sendSmsConsent = ({ data, onSuccess, contractType }) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setFamilyLoading(true))
			const { externalId, mobilePhone } = data

			const actionsMap = {
				eContract: api.contracts.sendSmsConsent,
				eAdContract: api.contracts.sendAdSmsConsent,
				eContractTerm: api.contracts.sendTermSmsConsent,
			}

			const apiCall = actionsMap[contractType]

			const res = await apiCall({ externalId, mobilePhone })

			if (res === '') {
				if (onSuccess(res)) dispatch(actions.setFamilyLoading(false))
			}
		} catch (error) {
			dispatch(actions.setFamilyLoading(false))
			message.error(error.response ? error.response.data.message : 'Ошибка отправки запроса')
		} finally {
			dispatch(actions.setFamilyLoading(false))
		}
	}
}

export const verifySmsConsent = ({ data, onSuccess, contractType }) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setFamilyLoading(true))
			const { externalId, confirmCode } = data

			const actionsMap = {
				eContract: api.contracts.verifySmsConsent,
				eAdContract: api.contracts.verifyAdSmsConsent,
				eContractTerm: api.contracts.verifyTermSmsConsent,
			}

			const apiCall = actionsMap[contractType]

			const res = await apiCall({ externalId, confirmCode })

			if (res === '') {
				if (onSuccess(res)) dispatch(actions.setFamilyLoading(false))
			}
		} catch (error) {
			dispatch(actions.setFamilyLoading(false))
			message.error(error.response ? error.response.data.message : 'Ошибка отправки запроса')
		} finally {
			dispatch(actions.setFamilyLoading(false))
		}
	}
}

export const getXml = ({ data, payload, onSuccess, contractType }) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setFamilyLoading(true))

			const actionsMap = {
				eContract: api.contracts.getXmlForRole,
				eAdContract: api.contracts.getAdXmlForRole,
				eContractTerm: api.contracts.getTermXmlForRole,
			}

			const apiCall = actionsMap[contractType]

			const xml = await apiCall(data, payload)

			if (xml) {
				if (onSuccess(xml)) dispatch(actions.setFamilyLoading(false))
			}
		} catch (error) {
			dispatch(actions.setFamilyLoading(false))
			message.error(
				t('errors.econtract.xml') +
					(error && error.response && error.response.data ? error.response.data.message : t('unknown_error')),
				10
			)
		}
	}
}

export const saveSign = ({ data, payload, onSuccess, contractType }) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setFamilyLoading(true))

			// Маппинг функций для контрактов
			const actionsMap = {
				eContract: api.contracts.saveSign,
				eAdContract: api.contracts.saveAdSign,
				eContractTerm: api.contracts.saveTermSign,
			}

			// Выбираем функцию для вызова API
			const apiCall = actionsMap[contractType]

			// Подготавливаем данные в зависимости от типа контракта
			const formattedData = contractType === 'eContractTerm' ? { xmlData: data } : data

			// Выполняем запрос
			const res = await apiCall(formattedData, payload)

			// Успешная обработка
			if (res) {
				if (onSuccess(res)) dispatch(actions.setFamilyLoading(false))
			}
		} catch (error) {
			dispatch(actions.setFamilyLoading(false))
			message.error(
				t('errors.econtract.send') +
					(error && error.response && error.response.data ? error.response.data.message : t('errors.unknown_error')),
				10
			)
		}
	}
}

export const irsDownloadExcel = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractsActions.getEmployerPermissionByBinLoading())

			const res = await api.contracts.irsDownloadExcel(data)
			if (res) {
				dispatch(contractsActions.getEmployerPermissionByBinSuccess())
				onSuccess(res)
				return res
			}
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractsActions.getEmployerPermissionByBinError())
		}
	}
}

export const getStatisticsNumber = () => {
	return async (dispatch) => {
		try {
			dispatch(contractsActions.getStatisticsNumber())

			// const res = await api.requirementLaborResources.getStatistic()

			// if (res) {
			// 	dispatch(contractsActions.getStatisticsNumberDone(res))
			// 	return res
			// }

			let res = {
				contractCount: 6400000,
				organizationCount: 765577,
				employeeCount: 5600000,
			}
			dispatch(contractsActions.getStatisticsNumberDone(res))
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractsActions.getStatisticsNumberFail())
		}
	}
}

export const getCheckDocument = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractsActions.getCheckDocument())

			let res

			if (data.type === 'sickLeave') {
				res = await api.contracts.checkDocumentsSl(data.id, { type: data.type })
			} else if (data.type === 'ACTN1') {
				res = await api.accidents.safetyDoc(data.id)
			} else {
				res = await api.contracts.checkDocuments(data.id, { type: data.type })
			}

			if (res) {
				dispatch(contractsActions.getCheckDocumentDone(res))
				onSuccess(res)
				return res
			}
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractsActions.getCheckDocumentFail())
		}
	}
}

export const earlyExitLeaveXml = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractsActions.earlyLeaveRegistrationXml())
			const res = await api.contracts.earlyExitLeaveRegistrationXml(data)
			dispatch(contractsActions.earlyLeaveRegistrationXmlDone(res))
			onSuccess(res)
		} catch (error) {
			dispatch(contractsActions.earlyLeaveRegistrationXmlFail())
			message.error(error.response?.data?.message)
		}
	}
}

export const sendSignedEarlyExitSocialLeave = ({ data, onSuccess }) => {
	return async (dispatch, getState) => {
		try {
			dispatch(contractsActions.setSocialLeaveIsLoading(true))
			await api.contracts.sendSignedSocialLeave(data)
			dispatch(contractsActions.setSocialLeaveIsSuccess(true))
			onSuccess()
		} catch (error) {
			message.error(error.response?.data?.message)
		} finally {
			dispatch(contractsActions.setSocialLeaveIsLoading(false))
		}
	}
}

export const earlyExitLeaveSave = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractsActions.setSocialLeaveIsLoading(true))
			await api.contracts.earlyExitLeaveSave(data)
			dispatch(contractsActions.setSocialLeaveIsSuccess(true))
			onSuccess()
		} catch (error) {
			dispatch(contractsActions.earlyLeaveRegistrationXmlFail())
			message.error(error.response?.data?.message)
		} finally {
			dispatch(contractsActions.setSocialLeaveIsLoading(false))
		}
	}
}

export const earlyExitLeaveDelete = ({ data, onSuccess, payload }) => {
	return async (dispatch) => {
		try {
			dispatch(contractsActions.setSocialLeaveIsLoading(true))
			let res

			if (payload?.status === 'SIGNED') {
				res = await api.contracts.deleteEarlyExitLeaveSave(data)
				onSuccess(res, true)
			} else {
				res = await api.contracts.deleteLocalEarlyExitLeaveSave(data?.socialLeaveExternalId)
				onSuccess(res, false)
			}
		} catch (error) {
			dispatch(contractsActions.earlyLeaveRegistrationXmlFail())
			dispatch(contractsActions.setSocialLeaveIsLoading(false))
			message.error(error.response?.data?.message)
		}
	}
}
